import { ConditionOperator } from '@invenco/common-domain/enums';

/**
 * Labels for every condition operator, read inline after a property ("Total
 * price <is greater than> …"); the `Record` type forces full enum coverage.
 *
 * The All/None/Some group operators all read as plain "is in"/"is not in": the
 * quantifier is already carried by the property name (e.g. "All SKUs"), and the
 * paired operators never appear together in one property's operator list.
 */
export const operatorLabels: Record<ConditionOperator, string> = {
  [ConditionOperator.EQUAL_TO]: 'is',
  [ConditionOperator.NOT_EQUAL_TO]: 'is not',
  [ConditionOperator.EQUAL_TO_CASE_INSENSITIVE]: 'is (case insensitive)',
  [ConditionOperator.NOT_EQUAL_TO_CASE_INSENSITIVE]: 'is not (case insensitive)',
  [ConditionOperator.STARTS_WITH]: 'starts with',
  [ConditionOperator.ENDS_WITH]: 'ends with',
  [ConditionOperator.STRING_CONTAINS]: 'contains',
  [ConditionOperator.STRING_DOES_NOT_CONTAIN]: 'does not contain',
  [ConditionOperator.CONTAINS]: 'contains',
  [ConditionOperator.DOES_NOT_CONTAIN]: 'does not contain',
  [ConditionOperator.CONTAINS_CASE_INSENSITIVE]: 'contains (case insensitive)',
  [ConditionOperator.DOES_NOT_CONTAIN_CASE_INSENSITIVE]: 'does not contain (case insensitive)',
  [ConditionOperator.LESS_THAN]: 'is less than',
  [ConditionOperator.LESS_THAN_OR_EQUAL_TO]: 'is less than or equal to',
  [ConditionOperator.GREATER_THAN]: 'is greater than',
  [ConditionOperator.GREATER_THAN_OR_EQUAL_TO]: 'is greater than or equal to',
  [ConditionOperator.IN]: 'is in',
  [ConditionOperator.NOT_IN]: 'is not in',
  [ConditionOperator.IN_CASE_INSENSITIVE]: 'is in (case insensitive)',
  [ConditionOperator.NOT_IN_CASE_INSENSITIVE]: 'is not in (case insensitive)',
  [ConditionOperator.ALL_IN_GROUP]: 'is in',
  [ConditionOperator.ALL_NOT_IN_GROUP]: 'is not in',
  [ConditionOperator.NONE_IN_GROUP]: 'is in',
  [ConditionOperator.NONE_NOT_IN_GROUP]: 'is not in',
  [ConditionOperator.SOME_IN_GROUP]: 'is in',
  [ConditionOperator.SOME_NOT_IN_GROUP]: 'is not in',
  [ConditionOperator.IS_EMPTY]: 'is empty',
  [ConditionOperator.IS_NOT_EMPTY]: 'is not empty',
};
